const scope = "durationToTarget";
export default scope;
